import { Box, CircularProgress } from '@mui/material';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useGetFilters } from '../hooks/useGetFilters';
import { useGetGrillaConsulta } from '../hooks/useGetGrillaConsulta';
import { useGetParametros } from '../hooks/useGetParametros';
import { useGetResultadosConsulta } from '../hooks/useGetResultadosConsulta';
import { ConsultasGeneralesFilters } from './components/ConsultasGeneralesFilters';
import './consultasGeneralesContent.scss';

export const ConsultasGeneralesContent = ({ setChildrenAction }) => {
    const [selectedDelegaciones, setSelectedDelegaciones] = useState([]);
    const [parametrosValues, setParametrosValues] = useState({});

    const {
        filters,
        handleChangeFilters,
        delegaciones,
        delegacionesLoading,
        consultasOptions
    } = useGetFilters();

    const {
        parametros,
        parametrosLoading,
        parametrosError
    } = useGetParametros(filters.idConsulta);

    const {
        resultados,
        loading: loadingResultados,
        onSearch: handleSearch,
    } = useGetResultadosConsulta();


    const consultaSelected = useMemo(() => {
        return consultasOptions.find(consulta => consulta.id === filters.idConsulta) || {};
    }, [consultasOptions, filters.idConsulta]);

    const { rows, columns } = useGetGrillaConsulta(resultados, consultaSelected.mostrarGrilla);

    useEffect(() => {
        setParametrosValues({});
    }, [filters.idConsulta]);

    const handleParametrosValuesChange = (name, value) => {
        setParametrosValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    useEffect(() => {
        setChildrenAction(() => (
            <Fragment>
                {consultaSelected.mostrarGrilla && <Box className='button-search'>
                    <CustomButton
                        isLoading={loadingResultados}
                        onClick={() => handleSearch({
                            consultaSelected,
                            selectedDelegaciones,
                            parametros,
                            parametrosValues,
                            esExportarExcel: false
                        })
                        }
                    >Buscar</CustomButton>
                </Box>}
                <CustomButton
                    isLoading={loadingResultados}
                    onClick={() => handleSearch({
                        consultaSelected,
                        selectedDelegaciones,
                        parametros,
                        parametrosValues,
                        esExportarExcel: true
                    })
                    }
                >Exportar</CustomButton>
            </Fragment>
        ))
    }, [
        consultaSelected,
        selectedDelegaciones,
        parametros,
        parametrosValues,
        loadingResultados
    ]);

    return (
        <div>
            <ConsultasGeneralesFilters
                filters={filters}
                handleChangeFilters={handleChangeFilters}
                handleSearch={handleSearch}
                disableFilters={loadingResultados}
                parametros={parametros}
                delegaciones={delegaciones}
                delegacionesLoading={delegacionesLoading}
                selectedDelegaciones={selectedDelegaciones}
                onChangeSelectedDelegaciones={setSelectedDelegaciones}
                consultasOptions={consultasOptions}
                consultaSelected={consultaSelected}
                parametrosLoading={parametrosLoading}
                parametrosError={parametrosError}
                parametrosValues={parametrosValues}
                onParametrosValuesChange={handleParametrosValuesChange}
            />
            {loadingResultados && consultaSelected.mostrarGrilla && (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            )}
            {!!rows?.length && consultaSelected.mostrarGrilla && !loadingResultados && <DataGridGenerico
                columns={columns}
                rows={rows}
                totalCount={rows?.length}
                loading={loadingResultados}
                toolbar={false}
            />}
        </div>
    );
}